export const ACTIONS = {
  GET_AD_DATE: "insight/anomaly/GET_AD_DATE",
  GET_BAR_CHART_DATE: "insight/anomaly/GET_BAR_CHART_DATE",
  GET_KPI_DATE: "insight/anomaly/GET_KPI_DATE",
  UPDATE_USAGE_TYPE: "insight/anomaly/UPDATE_USAGE_TYPE",
  GET_USAGE_AD_DATE: "insight/anomaly/GET_USAGE_AD_DATE",
  GET_USAGE_CIP_PROPS: "insight/anomaly/GET_USAGE_CIP_PROPS",
  GET_SELEC_TREND_CIRCUITS: "insight/anomaly/GET_SELEC_TREND_CIRCUITS",
  LATEST_SELEC_TREND_CIRCUITS: "insight/anomaly/LATEST_SELEC_TREND_CIRCUITS",
  PREV_SELEC_USG_CIRCUITS: "insight/anomaly/PREV_SELEC_USG_CIRCUITS",
  APP_USG_LIST: "insight/anomaly/APP_USG_LIST",
  PREV_APP_USG_LIST: "insight/anomaly/PREV_APP_USG_LIST"
};

export const setPrevAppUsgList = payload => dispatch => {
  dispatch({
    type: ACTIONS.PREV_APP_USG_LIST,
    payload: payload
  });
};

export const setAppUsgList = payload => dispatch => {
  dispatch({
    type: ACTIONS.APP_USG_LIST,
    payload: payload
  });
};

export const isPrevUsgList = payload => dispatch => {
  dispatch({
    type: ACTIONS.PREV_SELEC_USG_CIRCUITS,
    payload: payload
  });
};

export const isCircuitListSame = payload => dispatch => {
  dispatch({
    type: ACTIONS.LATEST_SELEC_TREND_CIRCUITS,
    payload: payload
  });
};

export const saveSelectedTrendCircuits = payload => dispatch => {
  dispatch({
    type: ACTIONS.GET_SELEC_TREND_CIRCUITS,
    payload: payload
  });
};

export const saveUsageCipProps = payload => dispatch => {
  dispatch({
    type: ACTIONS.GET_USAGE_CIP_PROPS,
    payload: payload
  });
};

export const saveUsageDateForTable = date => dispatch => {
  dispatch({
    type: ACTIONS.GET_USAGE_AD_DATE,
    payload: date
  });
};

export const saveDateForTable = date => dispatch => {
  dispatch({
    type: ACTIONS.GET_AD_DATE,
    payload: date
  });
};

export const saveKpiDateForTable = payload => dispatch => {
  dispatch({
    type: ACTIONS.GET_KPI_DATE,
    payload: payload
  });
};

export const updateBarChartData = payload => dispatch => {
  dispatch({
    type: ACTIONS.GET_BAR_CHART_DATE,
    payload: payload
  });
};

export const updateUsageType = payload => dispatch => {
  dispatch({
    type: ACTIONS.UPDATE_USAGE_TYPE,
    payload: payload
  });
}
